import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../models/error.model';
import { IMainApiService } from '../../../../../services/api.service';
import { IApiService } from '../../../../../services/api.service.base';
import { IClarification } from '../models/Clarifications.models';
import { ClarifyRequest, GetClarificationsRequest, IRequestClarificationRequest } from '../models/Clarifications.requests';

export interface IClarificationsApiService {
  clarifyAsync(request: ClarifyRequest): Promise<void | ACDLError>;
  getClarificationsAsync(request: GetClarificationsRequest): Promise<IClarification[] | ACDLError>;
  requestClarificationAsync(request: IRequestClarificationRequest): Promise<void | ACDLError>;
}

export namespace IClarificationsApiService {
  export const $: interfaces.ServiceIdentifier<IClarificationsApiService> = Symbol('CLARIFICATIONS_API_SERVICE');
}

@injectable()
export class ClarificationsApiService implements IClarificationsApiService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  async getClarificationsAsync(request: GetClarificationsRequest): Promise<IClarification[] | ACDLError> {
    return await this.apiService.getAsync(`/Clarifications/GetClarifications?projectId=${request.projectId}&imageId=${request.imageId}`);
  }

  async clarifyAsync(request: ClarifyRequest): Promise<void | ACDLError> {
    return await this.apiService.postAsync('/Clarifications/Clarify', request);
  }

  async requestClarificationAsync(request: IRequestClarificationRequest): Promise<void | ACDLError> {
    return await this.apiService.postAsync('/Clarifications/RequestClarification', request);
  }
}
